import { JsonObject, JsonProperty } from 'json2typescript';
import { Pagination } from '../../shared/pagination-model';

@JsonObject('AccountFilters')
export class AccountFilters extends Pagination {
  @JsonProperty('nameOrCode', String, true) nameOrCode: string = undefined;
}
